import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import landingWelcomeScreen from "../assets/images/landing-welcome-screen.png";

// Simple landing screen (Figma: Rectangle 28958) that animates into the Login screen
export default function Landing() {
  const navigate = useNavigate();
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Auto-advance after a short intro
    // 1) show for 1200ms, 2) play fade-out for 600ms, then navigate
    timeoutRef.current = setTimeout(() => setIsAnimatingOut(true), 1500);
    const navTimer = setTimeout(() => navigate("/login"), 1200 + 600);
    return () => {
      clearTimeout(timeoutRef.current);
      clearTimeout(navTimer);
    };
  }, [navigate]);

  const handleSkip = () => {
    // Allow users to skip immediately
    setIsAnimatingOut(true);
    // Navigate shortly after to let the fade-out play a bit
    setTimeout(() => navigate("/login"), 500);
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-[#0D0F11] select-none">
      <div
        className={
          "absolute inset-0 flex items-center justify-center transition-opacity duration-700 " +
          (isAnimatingOut ? "opacity-0" : "opacity-100")
        }
      >
        {/* object-contain, not object-cover: the "AI&" mark is baked into the
            top-right corner of this image. cover crops whichever edge has
            excess once the image is scaled to fill the screen, and a window
            wider (relative to its height) than the image's own 16:9 crops
            from the top — cutting that mark off on shorter Windows screens.
            contain always shows the whole image, letterboxed on a mismatched
            aspect ratio instead of cropped; the bars match this page's own
            near-black background closely enough to be unnoticeable. */}
        <img
          src={landingWelcomeScreen}
          alt="Parakh welcome screen"
          className="h-full w-full object-contain"
        />
      </div>

    </div>
  );
}
